import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import TipoCuentaMagaya from './TipoCuentaMagaya';

interface TipoCuentaMagayaTableProps {
  data: TipoCuentaMagaya[];
  columns: TableColumn<TipoCuentaMagaya>[];
  customStyles: Record<string, any>;
}

const TipoCuentaMagayaTable: React.FC<TipoCuentaMagayaTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<TipoCuentaMagaya>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default TipoCuentaMagayaTable;